import { render } from "./fabricLayout.vue?vue&type=template&id=37659230&scoped=true&ts=true"
import script from "./fabricLayout.vue?vue&type=script&lang=ts"
export * from "./fabricLayout.vue?vue&type=script&lang=ts"

import "./fabricLayout.vue?vue&type=style&index=0&id=37659230&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37659230"]])

export default __exports__